import { Badge, Card } from 'journey-ui'
import React, { useContext } from 'react'
import { sum } from '../../helpers'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { AddonItemRow } from './AddonItemRow'

interface Props {
  addon: Addon
}

export const AddonCard: React.FC<Props> = ({ addon }) => {
  const { form } = useContext(ItemPageContext)
  const selectedItems = form.children.filter((c) => addon.items.find((i) => c.addon_hash_id === addon.hash_id && c.size_name === i.size_name && c.name === i.name))
  const isMaxed = addon.max > 0 && sum(selectedItems.map((i) => i.quantity)) >= addon.max

  return (
    <Card>
      <div className="bg-primary text-primary-contrast p-2 flex justify-between items-center space-x-2 rounded">
        <span className="font-bold">
          {addon.title}
        </span>
        <div className="flex flex-shrink-0 items-center space-x-2">
          {addon.free ? (
            <Badge>
              {`${addon.free} free`}
            </Badge>
          ) : null}
          {addon.min ? (
            <Badge>
              {`${addon.min} min`}
            </Badge>
          ) : null}
          {addon.max ? (
            <Badge>
              {`${addon.max} max`}
            </Badge>
          ) : null}
        </div>
      </div>
      <div className="space-y-2 overflow-y-auto max-h-48">
        {addon.items.map((item) => <AddonItemRow key={item.hash_id} addon={addon} item={item} addonIsMaxed={isMaxed} />)}
      </div>
    </Card>
  )
}
